<template>
    <div class="secret-btns">
        <a href="#wrapper-content" v-smooth-scroll class="top-btn">
            <div class="in"><svgIcon name="arrow-top" class="icon-arrow-top"/></div>
            <small v-if="globalLang != 'kz/'">вверх</small>
            <small v-else>жоғары</small>
        </a>
    </div>  
</template>


<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'secret-btns',
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
    }
</script>